export * from "./jira-software-pricing-page.template";
export { JiraSoftwarePricingPageTemplate as default } from "./jira-software-pricing-page.template";
